import axios from 'axios';

const production = true; 
const domain = production?"scrapping-api.mvcspa.cl":"localhost:8000";

export const axiosService = axios.create({
    baseURL: production?`https://${domain}/`:`http://${domain}/`,
});